export default {
    NAME: "UCAS Widget",
    events: {
        productOpened: {
            name: "Product Opened",
            requiredFields: ["name"],
        },
        prospectLoggedIn: {
            name: "Prospect Logged In",
        },
        propsectConsentAgreed: {
            name: "Prospect UCAS Consent Agreed",
        },
        prospectAccountVerified: {
            name: "Prospect Account Verified",
        },
        prospectEmailChanged: {
            name: "Prospect Email Changed",
        },
        prospectRequestedVerificationCode: {
            name: "Prospect Requested Verification Code",
        },
    },
};
